<template>
    <div class="row">
        <div class="col">
            <div class="card">
                <div class="card-body">
                    <form class="form-horizontal">
                        <div class="row">
                            <!-- LEFT COLUMN: GENERICHE -->
                            <div class="col-12 col-xl-6">
                                <!-- Nome e Cognome -->
                                <div class="row">
                                    <div class="col">
                                        <text-input :form="form"
                                                    :label="'Cognome'"
                                                    name="last_name"
                                                    :readonly="readonly"/>
                                    </div>
                                    <div class="col">
                                        <text-input :form="form"
                                                    :label="'Nome'"
                                                    name="first_name"
                                                    :readonly="readonly"/>
                                    </div>
                                </div>

                                <!-- Full name (hidden, for compatibility) -->
                                <div class="row" style="display: none;">
                                    <div class="col">
                                        <text-input :form="form"
                                                    :label="'Nome completo'"
                                                    name="full_name"
                                                    :readonly="readonly"/>
                                    </div>
                                </div>
                                <!-- Categories -->
                                <div class="row">
                                    <div class="col-8">
                                        <multi-select-input :form="form"
                                                            :label="'Categorie'"
                                                            name="categories"
                                                            :options="$categories"
                                                            :readonly="readonly"
                                        />
                                    </div>
                                    <div class="col-4" style="padding-top:30px">
                                        <and-or-input :form="form"
                                                     name="categories_and_or"
                                                     :readonly="readonly"/>
                                    </div>
                                </div>

                                <!-- CARD TRATTAMENTO -->
                                <div class="card mb-3">
                                    <div class="card-header">
                                        Trattamento
                                    </div>
                                    <div class="card-body">
                                        <!-- Badge Section -->
                                        <h6>Badge</h6>
                                        <div class="row mb-2">
                                            <div class="col">
                                                <radio-input :form="form"
                                                             label="Ha il badge"
                                                             name="has_badge"
                                                             :options="[{id: 1, name: 'Sì'}, {id: 0, name: 'No'}]"
                                                             :readonly="readonly"/>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-6">
                                                <div class="card">
                                                    <div class="card-header">
                                                        Accredito
                                                    </div>
                                                    <div class="card-body">
                                                        <radio-input :label="'Badge'"
                                                                     :form="form"
                                                                     name="badge_latest"
                                                                     :options="$badge_types_accreditations"
                                                                     :readonly="readonly"/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-6">
                                                <div class="card">
                                                    <div class="card-header">
                                                        Subscriber
                                                    </div>
                                                    <div class="card-body">
                                                        <radio-input :label="'Badge'"
                                                                     :form="form"
                                                                     name="badge_latest"
                                                                     :options="$badge_types_subscribers"
                                                                     :readonly="readonly"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col">
<!--                                                <checkbox-input :form="form"-->
<!--                                                                :label="'Ritiro'"-->
<!--                                                                name="badge_collected"-->
<!--                                                                :readonly="readonly"/>-->
                                                <checkbox-input :form="form"
                                                                :label="'Free'"
                                                                name="non_paying"
                                                                :readonly="readonly"/>
                                            </div>
                                        </div>

                                        <div v-if="!advancedSearch">
                                            <hr>

                                            <!-- Hospitality Section -->
                                            <h6>Ospitalità</h6>
                                            <div class="row mb-2">
                                                <div class="col">
                                                    <radio-input :form="form"
                                                                 label="Ha l'ospitalità"
                                                                 name="has_hospitality"
                                                                 :options="[{id: 1, name: 'Sì'}, {id: 0, name: 'No'}]"
                                                                 :readonly="readonly"/>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-6">
                                                    <select-input :form="form"
                                                                  :label="'Tipo'"
                                                                  name="hospitality_type_id"
                                                                  :options="$hospitality_types"
                                                                  :readonly="readonly"/>
                                                </div>
                                                <div class="col-3">
                                                    <text-input :form="form"
                                                                type="number"
                                                                :label="'N. Giorni'"
                                                                name="hospitality_duration"
                                                                :readonly="readonly"/>
                                                </div>
                                                <div class="col-3" style="padding-top:30px">
                                                    <checkbox-input :form="form"
                                                                    :label="'Free'"
                                                                    name="hospitality_free"
                                                                    :readonly="readonly"/>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col">
                                                    <text-input :form="form"
                                                                :label="'Dove'"
                                                                name="hospitality_accomodation"
                                                                :readonly="readonly"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Note -->
                                <div class="row">
                                    <div class="col">
                                        <text-area-input :form="form"
                                                         :label="'Note'"
                                                         name="note"
                                                         :readonly="readonly"/>
                                    </div>
                                </div>

                                <!-- CARD DONATORE -->
                                <div class="card mb-3" v-if="!readonly && !advancedSearch">
                                    <div class="card-header">
                                        Aggiungi Donazione
                                    </div>
                                    <div class="card-body">
                                        <!-- Form per nuova donazione -->
                                        <div class="row">
                                            <div class="col-6">
                                                <text-input :form="form"
                                                            :label="'Data'"
                                                            name="new_donation_date"
                                                            type="date"
                                                            :readonly="false"/>
                                            </div>
                                            <div class="col-6">
                                                <text-input :form="form"
                                                            :label="'Importo'"
                                                            name="new_donation_amount"
                                                            type="number"
                                                            :readonly="false"/>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12">
                                                <text-input :form="form"
                                                            :label="'Campagna (opzionale)'"
                                                            name="new_donation_campaign"
                                                            :readonly="false"/>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col">
                                                <button @click.prevent="addDonation" class="btn btn-sm btn-primary">Aggiungi donazione</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- ACCORDION STORICO DONAZIONI -->
                                <div class="accordion mb-3" id="donationsHistoryAccordion" v-if="form.donations && form.donations.length > 0">
                                    <div class="card">
                                        <div class="card-header" id="donationsHistoryHeading">
                                            <h6 class="mb-0">
                                                <button class="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#donationsHistoryCollapse" aria-expanded="false" aria-controls="donationsHistoryCollapse">
                                                    <i class="fas fa-chevron-down"></i> Storico Donazioni
                                                </button>
                                            </h6>
                                        </div>
                                        <div id="donationsHistoryCollapse" class="collapse" aria-labelledby="donationsHistoryHeading" data-parent="#donationsHistoryAccordion">
                                            <div class="card-body">
                                                <div v-for="(donation, index) in form.donations" :key="donation.id || 'new-'+index" class="mb-2">
                                                    <div class="row">
                                                        <div class="col-4">
                                                            <small><strong>Data:</strong> {{ formatDate(donation.date) }}</small>
                                                        </div>
                                                        <div class="col-4">
                                                            <small><strong>Importo:</strong> {{ donation.amount }}</small>
                                                        </div>
                                                        <div class="col-4" v-if="!readonly">
                                                            <button @click.prevent="removeDonation(index)" class="btn btn-sm btn-danger">Rimuovi</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- CARD VOLONTARI -->
                                <div class="card mb-3" v-if="!advancedSearch">
                                    <div class="card-header">
                                        Volontari
                                    </div>
                                    <div class="card-body">
                                        <checkbox-input :form="form"
                                                        :label="'Volontario ' + latestEditionYear"
                                                        name="is_volunteer"
                                                        :readonly="readonly"/>
                                        <div v-if="form.volunteer_histories_years && form.volunteer_histories_years.length > 0" class="mt-2">
                                            <small><strong>Storico anni:</strong> {{ form.volunteer_histories_years.join(', ') }}</small>
                                        </div>
                                    </div>
                                </div>
                                <!-- Advanced Search (se enabled) -->
                                <div class="row" v-if="advancedSearch">
                                    <div class="col">
                                        <multi-select-input :form="form"
                                                            label="Tipi Badge"
                                                            name="badge_types"
                                                            :options="$badge_types"
                                                            valueLabel="name"
                                        />
                                    </div>
                                    <div class="col">
                                        <multi-select-input :form="form"
                                                            label="Anni Badge"
                                                            name="badge_years"
                                                            :options="$editions"
                                                            valueLabel="name"
                                                            :multiple="false"
                                        />
                                    </div>
                                </div>
                                <div class="row" v-if="advancedSearch">
                                    <div class="col">
                                        <radio-input :form="form"
                                                     label="Ha il badge"
                                                     name="has_badge"
                                                     :options="[{id: null, name: 'Tutti'}, {id: 1, name: 'Sì'}, {id: 0, name: 'No'}]"
                                                     :readonly="false"/>
                                    </div>
                                    <div class="col">
                                        <radio-input :form="form"
                                                     label="Ha l'ospitalità"
                                                     name="has_hospitality"
                                                     :options="[{id: null, name: 'Tutti'}, {id: 1, name: 'Sì'}, {id: 0, name: 'No'}]"
                                                     :readonly="false"/>
                                    </div>
                                </div>

                                <!-- RICERCA DONAZIONI -->
                                <div class="card mb-3" v-if="advancedSearch">
                                    <div class="card-header">
                                        Ricerca Donazioni
                                    </div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-6">
                                                <text-input :form="form"
                                                            :label="'Data donazione dal'"
                                                            name="donation_date_from"
                                                            type="date"
                                                            :readonly="false"/>
                                            </div>
                                            <div class="col-6">
                                                <text-input :form="form"
                                                            :label="'Data donazione al'"
                                                            name="donation_date_to"
                                                            type="date"
                                                            :readonly="false"/>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-6">
                                                <text-input :form="form"
                                                            :label="'Importo donazione min'"
                                                            name="donation_amount_min"
                                                            type="number"
                                                            :readonly="false"/>
                                            </div>
                                            <div class="col-6">
                                                <text-input :form="form"
                                                            :label="'Importo donazione max'"
                                                            name="donation_amount_max"
                                                            type="number"
                                                            :readonly="false"/>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12">
                                                <text-input :form="form"
                                                            :label="'Campagna'"
                                                            name="donation_campaign"
                                                            :readonly="false"/>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-6">
                                                <text-input :form="form"
                                                            :label="'Totale donazioni min'"
                                                            name="donation_total_min"
                                                            type="number"
                                                            :readonly="false"/>
                                            </div>
                                            <div class="col-6">
                                                <text-input :form="form"
                                                            :label="'Totale donazioni max'"
                                                            name="donation_total_max"
                                                            type="number"
                                                            :readonly="false"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- RICERCA VOLONTARI -->
                                <div class="card mb-3" v-if="advancedSearch">
                                    <div class="card-header">
                                        Ricerca Volontari
                                    </div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-12">
                                                <label>Modalità edizione</label>
                                                <radio-input :form="form"
                                                             name="volunteer_edition_mode"
                                                             :options="[
                                                                 {id: 'current', name: 'Solo edizione corrente'},
                                                                 {id: 'history', name: 'Solo storico'},
                                                                 {id: 'both', name: 'Entrambi'}
                                                             ]"
                                                             :readonly="false"/>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12">
                                                <multi-select-input :form="form"
                                                                    label="Edizioni"
                                                                    name="volunteer_edition_ids"
                                                                    :options="$editions"
                                                                    valueLabel="name"
                                                />
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12">
                                                <checkbox-input :form="form"
                                                                :label="'Ha fatto/fa volontario'"
                                                                name="volunteer_status"
                                                                :readonly="false"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- RICERCA OSPITALITÀ -->
                                <div class="card mb-3" v-if="advancedSearch">
                                    <div class="card-header">
                                        Ricerca Ospitalità
                                    </div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-12">
                                                <label>Modalità edizione</label>
                                                <radio-input :form="form"
                                                             name="hospitality_edition_mode"
                                                             :options="[
                                                                 {id: 'current', name: 'Solo edizione corrente'},
                                                                 {id: 'history', name: 'Solo storico'},
                                                                 {id: 'both', name: 'Entrambi'}
                                                             ]"
                                                             :readonly="false"/>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12">
                                                <multi-select-input :form="form"
                                                                    label="Edizioni"
                                                                    name="hospitality_edition_ids"
                                                                    :options="$editions"
                                                                    valueLabel="name"
                                                />
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-6">
                                                <select-input :form="form"
                                                              :label="'Tipo'"
                                                              name="hospitality_type_id"
                                                              :options="$hospitality_types"
                                                              :readonly="false"/>
                                            </div>
                                            <div class="col-6">
                                                <text-input :form="form"
                                                            :label="'Giorni'"
                                                            name="hospitality_duration"
                                                            type="number"
                                                            :readonly="false"/>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12">
                                                <text-input :form="form"
                                                            :label="'Dove'"
                                                            name="hospitality_accommodation"
                                                            :readonly="false"/>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12">
                                                <checkbox-input :form="form"
                                                                :label="'Free'"
                                                                name="hospitality_free"
                                                                :readonly="false"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- RICERCA NEWSLETTER -->
                                <div class="card mb-3" v-if="advancedSearch">
                                    <div class="card-header bg-info text-white">
                                        <i class="fas fa-envelope"></i> Ricerca Newsletter
                                    </div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-12">
                                                <multi-select-input :form="form"
                                                                    label="Liste Newsletter"
                                                                    name="newsletter_list_ids"
                                                                    :options="newsletterLists"
                                                                    valueLabel="name"
                                                />
                                                <small class="text-muted">
                                                    Seleziona una o più liste newsletter per trovare persone con business card iscritte a queste liste.
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- RIGHT COLUMN: ULTIMA EDIZIONE BFM -->
                            <div class="col-12 col-xl-6">
                                <div class="card">
                                    <div class="card-header">
                                        <strong>Ultima Edizione BFM {{ latestEditionYear }}</strong>
                                    </div>
                                    <div class="card-body">
                                        <!-- Badge Latest Info (Read-only display) -->
                                        <div v-if="form.badge_latest" class="mb-3">
                                            <h6>Badge</h6>
                                            <p>
                                                <small><strong>Tipo:</strong> {{ badgeLatestTypeName }}</small><br>
<!--                                                <small><strong>Ritiro:</strong> {{ form.badge_collected ? 'Sì' : 'No' }}</small><br>-->
                                                <small><strong>Non paga:</strong> {{ form.non_paying ? 'Sì' : 'No' }}</small>
                                            </p>
                                        </div>

                                        <!-- Hospitality Latest Info (Read-only display) -->
                                        <div v-if="form.hospitality_latest" class="mb-3">
                                            <h6>Ospitalità</h6>
                                            <p>
                                                <small><strong>Giorni:</strong> {{ form.hospitality_latest.duration || 'N/A' }}</small><br>
                                                <small><strong>Dove:</strong> {{ form.hospitality_latest.accomodation || 'N/A' }}</small><br>
                                                <small><strong>Tipo:</strong> {{ hospitalityLatestTypeName }}</small><br>
                                                <small><strong>Free:</strong> {{ form.hospitality_latest.free ? 'Sì' : 'No' }}</small>
                                            </p>
                                        </div>

                                        <hr>

                                        <!-- Storico Badge (Accordion) -->
                                        <div class="accordion mb-3" id="badgeHistoryAccordion" v-if="form.badges_history_sorted && form.badges_history_sorted.length > 0">
                                            <div class="card">
                                                <div class="card-header" id="badgeHistoryHeading">
                                                    <h6 class="mb-0">
                                                        <button class="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#badgeHistoryCollapse" aria-expanded="false" aria-controls="badgeHistoryCollapse">
                                                            <i class="fas fa-chevron-down"></i> Storico Badge
                                                        </button>
                                                    </h6>
                                                </div>
                                                <div id="badgeHistoryCollapse" class="collapse" aria-labelledby="badgeHistoryHeading" data-parent="#badgeHistoryAccordion">
                                                    <div class="card-body">
                                                        <small v-for="badge in form.badges_history_sorted" :key="badge.id">
                                                            {{ badge.edition.name }} → {{ badge.badge_type.name }}<br>
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Storico Ospitalità (Accordion) -->
                                        <div class="accordion mb-3" id="hospitalityHistoryAccordion" v-if="form.hospitalities_history_sorted && form.hospitalities_history_sorted.length > 0">
                                            <div class="card">
                                                <div class="card-header" id="hospitalityHistoryHeading">
                                                    <h6 class="mb-0">
                                                        <button class="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#hospitalityHistoryCollapse" aria-expanded="false" aria-controls="hospitalityHistoryCollapse">
                                                            <i class="fas fa-chevron-down"></i> Storico Ospitalità
                                                        </button>
                                                    </h6>
                                                </div>
                                                <div id="hospitalityHistoryCollapse" class="collapse" aria-labelledby="hospitalityHistoryHeading" data-parent="#hospitalityHistoryAccordion">
                                                    <div class="card-body">
                                                        <small v-for="hospitality in form.hospitalities_history_sorted" :key="hospitality.id">
                                                            {{ hospitality.edition.name }} → {{ hospitality.duration }} gg, {{ hospitality.hospitality_type?.name || 'N/A' }}, {{ hospitality.accomodation }}, Free: {{ hospitality.free ? 'Sì' : 'No' }}<br>
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Stato Persona Card -->
                                <div class="card mt-3">
                                    <div class="card-header">
                                        Stato Persona
                                    </div>
                                    <div class="card-body">
                                        <checkbox-input :form="form"
                                                        :label="'Pensionat*'"
                                                        name="retired"
                                                        :readonly="readonly"/>
                                        <checkbox-input :form="form"
                                                        :label="'Decedut*'"
                                                        name="deceased"
                                                        :readonly="readonly"/>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row"
                             v-if="readonly"
                             style="padding-bottom: 10px;">
                            <div class="col-12 col-xl-6"
                                 v-if="form.related_people_cards && form.related_people_cards.length > 0">
                                <ul class="nav nav-pills">
                                    <router-link v-for="card in form.related_people_cards"
                                                 :to="'/people-card/'+card.id"
                                                 :key="card.id">
                                        <li class="nav-item nav">
                                            <a class="nav-link active people"
                                               href="#">{{ card.last_name }} {{ card.first_name }}</a>
                                        </li>
                                    </router-link>&nbsp;&nbsp;&nbsp;&nbsp;
                                </ul>
                            </div>
                            <div class="col-12 col-xl-6"
                                 v-if="form.company_cards && form.company_cards.length > 0">
                                <ul class="nav nav-pills">
                                    <router-link v-for="card in form.company_cards"
                                                 :to="'/company-card/'+card.id"
                                                 :key="card.id">
                                        <li class="nav-item">
                                            <a class="nav-link active company" href="#">{{ card.full_name }} {{
                                                    card.last_name
                                                }}</a>
                                        </li>
                                    </router-link>&nbsp;&nbsp;&nbsp;
                                </ul>
                            </div>
                        </div>

                        <div class="row"
                             v-else
                             style="padding-bottom: 10px;">
                            <div class="col-12 col-xl-6">
                                <multi-select-input :form="form"
                                                    label="Persone collegate"
                                                    name="related_people_cards"
                                                    :searchChange="(queryString) => asyncPeopleFind(queryString)"
                                                    valueLabel="full_name"
                                />
                            </div>
                            <div class="col-12 col-xl-6">
                                <multi-select-input :form="form"
                                                    label="Aziende collegate"
                                                    name="company_cards"
                                                    :searchChange="(queryString) => asyncCompaniesFind(queryString)"
                                                    valueLabel="full_name"
                                />
                            </div>
                        </div>

                        <div class="row" v-if="!readonly && type !== 'search'">
                            <div class="col-4">
                                <button class="btn btn-sm company" @click.prevent="newBusinessCard">Aggiungi
                                    business card
                                </button>
                            </div>
                        </div>

                        <div class="row" v-if="form.business_cards">
                            <div class="col">
                                <div class="row">
                                    <div class="col-12" v-for="(card, index) in form.business_cards" :key="index">
                                        <div class="card mb-3">
                                            <div class="card-header"
                                                 v-if="readonly && card.company_cards[0]">
                                                <router-link
                                                    :to="'/company-card/'+card.company_cards[0].id">
                                                    <a href="#" class="btn btn-sm company">{{
                                                            card.company_cards[0].full_name
                                                        }}</a>
                                                </router-link>
                                            </div>
                                            <div class="card-header"
                                                 v-if="!readonly">
                                                <div class="row">
                                                    <div class="col">
                                                        <business-card-company-multi-select-input
                                                            :form="form"
                                                            :searchChange="(queryString) => asyncCompaniesFind(queryString)"
                                                            valueLabel="full_name"
                                                            :max="1"
                                                            :nested-index="index"
                                                            name="company_cards"
                                                        />
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col">
                                                        <button @click.prevent="removeBusinessCard(card)"
                                                                class="btn btn-sm btn-danger">Rimuovi
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="row">
                                                    <!-- Left column: Business card fields -->
                                                    <div class="col-12 col-lg-7">
                                                        <nested-text-input :form="form"
                                                                           :label="'Email'"
                                                                           name="email"
                                                                           nested-key="business_cards"
                                                                           :nested-index="index"
                                                                           :readonly="readonly"
                                                        />
                                                        <nested-text-input :form="form"
                                                                           :label="'Telefono'"
                                                                           name="phone"
                                                                           nested-key="business_cards"
                                                                           :nested-index="index"
                                                                           :readonly="readonly"
                                                        />
                                                        <nested-text-input :form="form"
                                                                           :label="'Descrizione'"
                                                                           name="description"
                                                                           nested-key="business_cards"
                                                                           :nested-index="index"
                                                                           :readonly="readonly"
                                                        />
                                                        <nested-text-input :form="form"
                                                                           :label="'Via'"
                                                                           name="street"
                                                                           nested-key="business_cards"
                                                                           :nested-index="index"
                                                                           :readonly="readonly"
                                                        />
                                                        <nested-text-input :form="form"
                                                                           :label="'Città'"
                                                                           name="city"
                                                                           nested-key="business_cards"
                                                                           :nested-index="index"
                                                                           :readonly="readonly"
                                                        />
                                                        <nested-text-input :form="form"
                                                                           :label="'CAP'"
                                                                           name="zip_code"
                                                                           nested-key="business_cards"
                                                                           :nested-index="index"
                                                                           :readonly="readonly"
                                                        />
                                                        <nested-text-input :form="form"
                                                                           :label="'Provincia'"
                                                                           name="state"
                                                                           nested-key="business_cards"
                                                                           :nested-index="index"
                                                                           :readonly="readonly"
                                                        />
                                                        <nested-text-input :form="form"
                                                                           :label="'Nazione'"
                                                                           name="country"
                                                                           nested-key="business_cards"
                                                                           :nested-index="index"
                                                                           :readonly="readonly"
                                                        />
                                                        <nested-text-input :form="form"
                                                                           :label="'Note'"
                                                                           name="note"
                                                                           nested-key="business_cards"
                                                                           :nested-index="index"
                                                                           :readonly="readonly"
                                                        />
                                                        <nested-text-input :form="form"
                                                                           :label="'Mansione'"
                                                                           name="job_title"
                                                                           nested-key="business_cards"
                                                                           :nested-index="index"
                                                                           :readonly="readonly"
                                                        />
                                                    </div>

                                                    <!-- Right column: Newsletter box -->
                                                    <div class="col-12 col-lg-5" v-if="card.id && type !== 'search'">
                                                        <brevo-newsletter-box
                                                            :business-card-id="card.id"
                                                            :email="card.email"
                                                            :readonly="readonly"
                                                            @subscriptions-updated="onNewsletterSubscriptionsUpdated"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SelectInput from "../components/SelectInput"
import TextAreaInput from "../components/TextAreaInput"
import MultiSelectInput from "../components/MultiSelectInput"
import TextInput from "../components/TextInput"
import {HasError} from "vform/src/components/bootstrap4"
import Multiselect from "vue-multiselect"
import sharedState from "../sharedState"
import CheckboxInput from "../components/CheckboxInput"
import RadioInput from "../components/RadioInput"
import NestedTextInput from "./NestedTextInput"
import companyCards from "../services/api/companyCards"
import peopleCards from "../services/api/peopleCards"
import BusinessCardCompanyMultiSelectInput from "./BusinessCardCompanyMultiSelectInput"
import AndOrInput from "./AndOrInput.vue"
import BrevoNewsletterBox from "./BrevoNewsletterBox.vue"

export default {
    components: {
        AndOrInput,
        BusinessCardCompanyMultiSelectInput,
        NestedTextInput,
        SelectInput,
        TextAreaInput,
        MultiSelectInput,
        TextInput,
        HasError,
        Multiselect,
        CheckboxInput,
        RadioInput,
        BrevoNewsletterBox
    },
    name: "PeopleCardForm",
    props: {
        form: Object,
        readonly: {type: Boolean, default: false},
        type: {type: String, default: 'show'},
        advancedSearch: {type: Boolean, default: false}
    },
    data() {
        return {
            sharedState: sharedState,
            newsletterLists: [],
        }
    },
    mounted() {
        // Load newsletter lists for advanced search
        if (this.advancedSearch) {
            this.loadNewsletterLists();
        }
    },
    computed: {
        latestEditionYear() {
            // Get latest edition year from badge_latest or fallback
            if (this.form.badge_latest && this.form.badge_latest.edition) {
                return this.form.badge_latest.edition.name
            }
            if (this.form.latestBadgeYear) {
                return this.form.latestBadgeYear
            }
            return ''
        },
        badgeLatestTypeName() {
            if (this.form.badge_latest && this.form.badge_latest.badge_type) {
                return this.form.badge_latest.badge_type.name
            }
            // Fallback: find badge type from $badge_types by ID
            const badgeTypeId = this.form.badge_latest
            if (badgeTypeId && this.sharedState.$badge_types) {
                const badgeType = this.sharedState.$badge_types.find(bt => bt.id === badgeTypeId)
                return badgeType ? badgeType.name : 'N/A'
            }
            return 'N/A'
        },
        hospitalityLatestTypeName() {
            if (this.form.hospitality_latest && this.form.hospitality_latest.hospitality_type) {
                return this.form.hospitality_latest.hospitality_type.name
            }
            return 'N/A'
        }
    },
    methods: {
        async asyncCompaniesFind(queryString) {
            return await companyCards.index(queryString)
        },
        async asyncPeopleFind(queryString) {
            return await peopleCards.index(queryString)
        },
        newBusinessCard() {
            this.form.business_cards.unshift({company_cards: null})
        },
        removeBusinessCard(card) {
            let index = this.form.business_cards.findIndex(item => item.id === card.id)
            this.form.business_cards.splice(index, 1)
        },
        addDonation() {
            // Validate inputs
            if (!this.form.new_donation_date || !this.form.new_donation_amount) {
                alert('Data e importo sono obbligatori')
                return
            }

            // Initialize donations array if not exists
            if (!this.form.donations) {
                this.form.donations = []
            }

            // Add new donation
            this.form.donations.push({
                date: this.form.new_donation_date,
                amount: this.form.new_donation_amount,
                campaign: this.form.new_donation_campaign || null
            })

            // Clear input fields
            this.form.new_donation_date = null
            this.form.new_donation_amount = null
            this.form.new_donation_campaign = null
        },
        removeDonation(index) {
            if (confirm('Sei sicuro di voler rimuovere questa donazione?')) {
                this.form.donations.splice(index, 1)
            }
        },
        formatDate(dateString) {
            if (!dateString) return 'N/A'
            const date = new Date(dateString)
            return date.toLocaleDateString('it-IT')
        },
        onNewsletterSubscriptionsUpdated(data) {
            // Optional: Show toast notification or handle subscription update
            console.log('Newsletter subscriptions updated:', data)
            // You can emit this event up to the parent if needed
            this.$emit('newsletter-updated', data)
        },
        async loadNewsletterLists() {
            try {
                const response = await axios.get('/api/v1/brevo/lists');
                if (response.data.success) {
                    this.newsletterLists = response.data.lists;
                } else {
                    console.error('Failed to load newsletter lists:', response.data.message);
                }
            } catch (error) {
                console.error('Error loading newsletter lists:', error);
                // Graceful degradation - continue without newsletter filter
                this.newsletterLists = [];
            }
        }
    }
}
</script>

<style scoped>

</style>
